import React, { memo } from 'react';
import { ForgotForm } from '../../components/auth/forgot';

const ForgotScreen = memo(() => {
  return (
    <div className="flex flex-1 bg-white w-full h-[100vh]">
      <ForgotForm />
    </div>
  );
});

ForgotScreen.displayName = 'ForgotScreen';

export { ForgotScreen };
